<div class="w-100 float-left">
    <h5 class="b-b pb-3 medium mb-0">{{'mobileAppManagement'|translate}}</h5>

    <div class="w-100 float-left my-4">
        <button class="btn btn-primary float-right" (click)="createMobileApp()">{{'createMobileApp'|translate}}</button>
    </div>
    <div class="w-100 float-left">
        <div class="w-100 float-left">
            <div class="light-bg w-100 float-left p-2 grid-details">
                <!--  <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                     <div class="checkbox checkbox-primary"><input id="checkbox2" type="checkbox"><label for="checkbox2" class="mb-md-0"></label></div>
                 </div> -->
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 medium"> {{'appName'|translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> {{'appKey'|translate}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium"> {{'androidVer'|translate}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium"> {{'iosVer'|translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> {{'firebaseKey'|translate}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium"> {{'redirectUrlAndroid'|translate}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <h6 class="mb-lg-0 medium"> {{'redirectUrliOS'|translate}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <h6 class="mb-lg-0 medium"> {{'action'|translate}} </h6>
                </div>
            </div>
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let app of mobileApps">
                <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <div class="checkbox checkbox-primary"><input id="checkbox3" type="checkbox"><label for="checkbox3" class="mb-md-0"></label></div>
                </div> -->
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{app.mobileAppName}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 text-truncate text-primary" (click)="viewPerformanceTable()">
                        {{app.mobileAppKey}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{app.versionAndroid}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{app.versionIos}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 text-truncate">{{app.fireBaseKey}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate">{{app.redirectUrlAndroid}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate">{{app.redirectUrlIos}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <div>
                        <i class="fa fa-edit" (click)="updateMobileApp(app)"></i>
                        <!-- <i class="fa fa-trash ml-2" (click)="deleteMobileApp(app)"></i> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- PAGINATION -->
        <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
            <h6 class="float-left mb-0"> {{startingPage}} - {{endingPage}} {{'itemsOf'}} {{collectionSize}} </h6>
            <div class="float-left ml-2 align-v-center">
                <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
                <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                        (change)="OnPageSizeChanged($event.target.value)">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </select>
            </div>
            <div style="flex-grow: 1;"></div>
            <ngb-pagination [collectionSize]="collectionSize" [rotate]="true" [pageSize]="pageSize" [maxSize]="5"
                            [ellipses]="false"
                            [(page)]="page" [boundaryLinks]="true" (pageChange)="onPageChange($event)"
                            class="float-right"></ngb-pagination>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/superAdmin/mobileAppManagement.html